var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ib-grid-view-placeholder-card-wrapper placeholder-card large",class:{'disabled': _vm.disabled}},[_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"avatar-placeholder",class:_vm.variant}),_c('div',{staticClass:"stripe-medium"}),_c('div',{staticClass:"stripe-small"}),_c('div',{staticClass:"stripe-large"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }